<template>
  <img
    v-if="imgSrc"
    :src="imgSrc"
    class="avatar custom"
    :style="[$attrs.style || {}, { width: size, height: size }]"
  />
  <font-awesome-icon
    v-else
    icon="circle-user"
    class="avatar generic"
    :style="{ fontSize: size, width: size }"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useImage } from '@vueuse/core'

const LOADING_IMAGE = '/img/fa-user-circle.png'
const ERROR_IMAGE = LOADING_IMAGE

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  url: String,
  size: {
    type: String,
    default: '3rem'
  }
})

const imageOptions = computed(() => ({ src: props.url || LOADING_IMAGE }))

const logImageLoadError = (error: unknown) => {
  console.warn('Failed to load avatar image', props.url, error)
}

const { error, isLoading } = useImage(imageOptions, { onError: logImageLoadError })
const imgSrc = computed(() => {
  if (!props.url) return null
  if (isLoading.value) return LOADING_IMAGE
  if (error.value) return ERROR_IMAGE
  return props.url
})

</script>

<style scoped>
.avatar {
  vertical-align: middle;

  &.custom {
    border-radius: 50%;
  }

  &.generic {
    color: #aaa;
  }

  :deep(.img) {
    border-radius: 50%;
  }
}
</style>
